document.addEventListener("DOMContentLoaded", () => {
  const handleDiscount = async (event) => {
    // Get elements from the current DOM (they might be from the new drawer after replacement)
    const discountButton = document.getElementById("discount-button");
    const discountError = document.getElementById("discount-error");
    const discountErrorMessage = document.getElementById(
      "discount-error-message"
    );
    const cta = document.getElementById("CartDrawer-Checkout");
    
    if (
      !event.target.matches("#discount-button") &&
      !event.target.matches(".discounts__discount-remove") &&
      event.type === "click"
    ) {
      return;
    }
    if (event.type === "keyup" && !event.target.matches("#discount-input")) {
      return;
    }
    if (event.type === "paste" && !event.target.matches("#discount-input")) {
      return;
    }
    event.preventDefault();
    if (event.type === "paste") {
      event.stopImmediatePropagation();
      const text = event.clipboardData.getData("text");
      const discountInput = document.getElementById("discount-input");
      if (discountInput) {
        discountInput.value = text;
      }
    }
    
    const discountInput = document.getElementById("discount-input");
    const discountCode = discountInput ? discountInput.value : "";
    const isRemovingDiscount = event.target.matches(".discounts__discount-remove");
    
    console.log("ds", discountCode, "isRemoving:", isRemovingDiscount);

    // Only require discount code if we're not removing a discount
    if (discountCode === "" && !isRemovingDiscount) {
      // discountError.classList.remove("hidden");
      // discountErrorMessage.textContent = "נא להזין קוד הנחה";
      // setTimeout(() => {
      //   discountError.classList.add("hidden");
      // }, 3000);
      return;
    }
    if (discountButton) {
      const spinner = discountButton.querySelector(".loading__spinner");
      if (spinner) {
        spinner.classList.remove("hidden");
      }
      discountButton.classList.add("loading");
    }

    if (cta) {
      cta.classList.add("loading");
      const ctaSpinner = cta.querySelector(".loading__spinner");
      if (ctaSpinner) {
        ctaSpinner.classList.remove("hidden");
      }
    }
    
    let cartUpdateResponse;
    if (isRemovingDiscount) {
      // Remove discount by updating cart with empty discount code
      const formData = new FormData();
      formData.append('discount', '');
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
      
      cartUpdateResponse = await fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        body: formData
      });
    } else {
      // Apply discount code
      const formData = new FormData();
      formData.append('discount', discountCode);
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
      
      cartUpdateResponse = await fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        body: formData
      });
    }

    // Get the updated cart drawer content
    const updatedDrawerReq = await fetch(
      `${routes.cart_url}?section_id=cart-drawer`
    );
    const updatedDrawerText = await updatedDrawerReq.text();
    const updatedDrawerHtml = new DOMParser().parseFromString(
      updatedDrawerText,
      "text/html"
    );
    
    const oldTotal = document.querySelector("#CartDrawer-Checkout span");
    const newTotal = updatedDrawerHtml.querySelector(
      "#CartDrawer-Checkout span"
    );

    const oldDrawer = document.querySelector("cart-drawer");
    const newDrawer = updatedDrawerHtml.querySelector("cart-drawer");

    // Check if the cart was updated successfully
    const cartUpdateText = await cartUpdateResponse.text();
    let cartUpdateData = null;
    
    // Try to parse as JSON, but handle cases where HTML is returned
    try {
      cartUpdateData = JSON.parse(cartUpdateText);
    } catch (error) {
      console.log('Cart update response is not JSON, treating as successful update');
      cartUpdateData = { success: true };
    }
    
    // For discount removal, we should always update the drawer
    // For discount application, we check if the total changed or if there are errors
    if (isRemovingDiscount || !oldTotal.isEqualNode(newTotal) || (cartUpdateData && cartUpdateData.errors)) {
      newDrawer.classList.add("active");
      oldDrawer.replaceWith(newDrawer);
      const newDiscountError = newDrawer.querySelector("#discount-error");
      if (newDiscountError) {
        newDiscountError.classList.add("hidden");
      }
      
      // Clear the discount input field after successful removal
      if (isRemovingDiscount) {
        const newDiscountInput = newDrawer.querySelector("#discount-input");
        if (newDiscountInput) {
          newDiscountInput.value = "";
        }
      }
      
      // Reset loading states after successful update
      if (discountButton) {
        const spinner = discountButton.querySelector(".loading__spinner");
        if (spinner) {
          spinner.classList.add("hidden");
        }
        discountButton.classList.remove("loading");
      }
      if (cta) {
        cta.classList.remove("loading");
        const ctaSpinner = cta.querySelector(".loading__spinner");
        if (ctaSpinner) {
          ctaSpinner.classList.add("hidden");
        }
      }
      return;
    } else {
      // Show error for invalid discount code
      if (!isRemovingDiscount) {
        if (discountButton) {
          const spinner = discountButton.querySelector(".loading__spinner");
          if (spinner) {
            spinner.classList.add("hidden");
          }
          discountButton.classList.remove("loading");
        }
        if (discountError) {
          discountError.classList.remove("hidden");
        }
        if (cta) {
          cta.classList.remove("loading");
          const ctaSpinner = cta.querySelector(".loading__spinner");
          if (ctaSpinner) {
            ctaSpinner.classList.add("hidden");
          }
        }
        if (discountErrorMessage) {
          discountErrorMessage.textContent = "קוד ההנחה אינו תקין";
        }
        if (discountError) {
          setTimeout(() => {
            discountError.classList.add("hidden");
          }, 3000);
        }
      } else {
        // For removal, just reset the loading states
        if (discountButton) {
          const spinner = discountButton.querySelector(".loading__spinner");
          if (spinner) {
            spinner.classList.add("hidden");
          }
          discountButton.classList.remove("loading");
        }
        if (cta) {
          cta.classList.remove("loading");
          const ctaSpinner = cta.querySelector(".loading__spinner");
          if (ctaSpinner) {
            ctaSpinner.classList.add("hidden");
          }
        }
      }
    }
  };

  const debounced = debounce((e) => {
    handleDiscount(e);
  }, 2000);

  // Use event delegation to handle dynamically added elements
  document.addEventListener("keyup", debounced);
  document.addEventListener("paste", handleDiscount, true);
  document.addEventListener("click", handleDiscount);
});
